import React from "react";
import SectionHeading from "components/SectionHeading";
import classes from "../style.module.scss";
import SoftwareLicenceContent from "./Content";

export default () => (
    <div>
        <SectionHeading
            title="Software Licensing Agreement"
            subtitle="Terms governing the licensing and use of the Volta SNAP software."
        />
        <div className={classes.contentWrapper}>
            <SoftwareLicenceContent />
        </div>
    </div>
);
